//----this is playlist pitchment---

import "./tools.scss";
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Grid,
  InputLabel,
  TextField,
  Box,
  Button,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Chip,
  Pagination,
  Typography,
  Fade,
  Card,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  API_URL,
  guidelinesTools,
  guidelinesToolsLyrics,
  trackTitleLanguage,
} from "../../constants";
import SelectCmp from "react-select";
import SaveIcon from "@mui/icons-material/Save";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import HistoryIcon from "@mui/icons-material/History";
import CustomShowModal from "../../components/Common/CustomShowModal";
import { useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Instagram from "@mui/icons-material/Instagram";
import Facebook from "@mui/icons-material/Facebook";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import PersonIcon from "@mui/icons-material/Person";
import { getHeaders, toastError, toastSuccess } from "../../utils";
import * as actions from "./actions";
import axios from "axios";
import SEO from "../../components/SEO";
const selectStyles = {
  control: (base, state) => ({
    ...base,
    background: "white",
    borderRadius: "8px",
    minHeight: "42px",
    borderColor: state.isFocused ? "#1a73e8" : "#e0e0e0",
    borderWidth: "2px",
    fontFamily: "'DM Sans', sans-serif",
    fontSize: "1rem",
    boxShadow: "none",
    '&:hover': {
      borderColor: "#1a73e8",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  singleValue: (defaultStyles) => ({
    ...defaultStyles,
    color: "#202124",
    fontFamily: "'DM Sans', sans-serif",
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "#80868b",
    fontFamily: "'DM Sans', sans-serif",
  }),
  option: (defaultStyles, state) => ({
    ...defaultStyles,
    backgroundColor: state.isSelected ? "#1a73e8" : state.isFocused ? "#e3f2fd" : "white",
    color: state.isSelected ? "white" : "#202124",
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    '&:active': {
      backgroundColor: "#1a73e8",
    },
  }),
};

const platformOptions = [
  { value: "Youtube Content ID", label: "Youtube Content ID" },
];

const policyOptions = [
  { value: "Monetize", label: "Monetize" },
  { value: "Remove", label: "Remove" },
  { value: "Block", label: "Block" },
];

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const moodsOptions = [
  "Chill",
  "Motivation",
  "Happy",
  "Energetic",
  "Sad",
  "Romantic",
  "Sexy",
  "Spirtual",
  "Relax",
  "None of these",
];

const PageContainer = styled(Box)({
  minHeight: 'calc(100vh - 64px)',
  background: 'linear-gradient(135deg, #e8eef3 0%, #dce4ec 100%)',
  padding: '32px 24px',
});

const PageHeader = styled(Box)({
  marginBottom: '32px',
  textAlign: 'center',
  '& h1': {
    fontSize: '2rem',
    fontWeight: 700,
    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    fontFamily: "'DM Sans', sans-serif",
    margin: 0,
  },
});

const FormCard = styled(Card)({
  borderRadius: '16px',
  padding: '32px',
  background: 'white',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
  marginBottom: '32px',
});

const SectionTitle = styled(Typography)({
  fontFamily: "'DM Sans', sans-serif",
  fontSize: '1.5rem',
  fontWeight: 700,
  color: '#202124',
  marginBottom: '24px',
  marginTop: '32px',
});

const StyledInputLabel = styled(InputLabel)({
  fontFamily: "'DM Sans', sans-serif",
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#202124',
  marginBottom: '8px',
  display: 'block',
});

const WarningCard = styled(Box)({
  background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
  borderRadius: '16px',
  padding: '20px 24px',
  marginBottom: '24px',
  border: '2px solid #ff9800',
  boxShadow: '0 4px 12px rgba(255, 152, 0, 0.15)',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '16px',
  '& .warning-icon': {
    color: '#f57c00',
    fontSize: '28px',
    marginTop: '2px',
  },
  '& .warning-content': {
    flex: 1,
    '& p': {
      fontFamily: "'DM Sans', sans-serif",
      fontSize: '0.95rem',
      fontWeight: 500,
      color: '#5d4037',
      lineHeight: 1.6,
      margin: 0,
    },
  },
});

const StyledButton = styled(Button)(({ theme }) => ({
  fontFamily: "'DM Sans', sans-serif",
  background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
  fontSize: '1rem',
  fontWeight: 600,
  height: 48,
  minWidth: 160,
  borderRadius: '12px',
  color: "white",
  textTransform: 'none',
  boxShadow: '0 4px 12px rgba(26, 115, 232, 0.3)',
  transition: 'all 0.3s ease',
  "&:hover": {
    background: 'linear-gradient(135deg, #1557b0 0%, #009688 100%)',
    boxShadow: '0 6px 20px rgba(26, 115, 232, 0.4)',
    transform: 'translateY(-2px)',
  },
}));

const CssTextField = styled(TextField)(({ theme }) => ({
  fontFamily: "'DM Sans', sans-serif",
  "& .MuiOutlinedInput-root": {
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    fontFamily: "'DM Sans', sans-serif",
    "& fieldset": {
      borderColor: '#e0e0e0',
      borderWidth: '2px',
    },
    "&:hover fieldset": {
      borderColor: '#1a73e8',
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1a73e8",
      borderWidth: "2px",
    },
  },
  "& .MuiInputBase-input": {
    color: '#202124',
    fontFamily: "'DM Sans', sans-serif",
  },
  "& label": {
    fontFamily: "'DM Sans', sans-serif",
    color: "#5f6368",
    fontWeight: 600,
  },
  "& label.Mui-focused": {
    color: "#1a73e8",
  },
  "& .MuiFormHelperText-root": {
    fontFamily: "'DM Sans', sans-serif",
    color: "#5f6368",
  },
}));

const StyledTableContainer = styled(TableContainer)({
  borderRadius: '16px',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
  backgroundColor: 'white',
  overflow: 'hidden',
  marginTop: '24px',
});

const StyledTableHead = styled(TableHead)({
  background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
  '& .MuiTableCell-head': {
    color: 'white',
    fontWeight: 700,
    fontSize: '0.95rem',
    fontFamily: "'DM Sans', sans-serif",
    borderBottom: 'none',
    padding: '16px',
  },
});

const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8f9fa',
  },
  '&:hover': {
    backgroundColor: '#e3f2fd',
    transition: 'all 0.2s ease',
  },
  '& .MuiTableCell-root': {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.9rem',
    color: '#202124',
    borderBottom: '1px solid #e0e0e0',
    padding: '14px 16px',
  },
});

const intitalProfileState = {
  release_id: "",
  release_title: "",
  audio_title: "",
  artist: "",
  facebook_link: "", // single url
  instagram_link: "", // single url
};

const intitalPlaylistState = {
  release_id: 1,
  release_title: "",
  audio_title: "",
  press_release: [], // multi url
  social_media: [], // multi url
  artwork_asset: "", // single url
  additional_assets: "", // single url
  moods: [], // multi url
  why_pitch: "",
  quick_pitch: "",
  additional_info: "",
};

function isValidUrl(str) {
  const pattern = new RegExp(
    "^([a-zA-Z]+:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR IP (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment locator
    "i"
  );
  return pattern.test(str);
}

export default function Tools(props) {
  const { setLoader = () => {} } = props;
  const { pathname } = useLocation();

  const [toolType, setToolType] = useState("profile");
  const [releases, setReleases] = useState([]);
  const [songs, setSongs] = useState([]);
  const [dataHistory, setDataHistory] = useState([]);
  const [guidelinesOpen, setGuidelinesOpen] = useState(false);
  const [selectedRelease, setSelectedRelease] = useState(null);
  const [selectedSong, setselectedSong] = useState(null);
  const [data, setData] = useState(
    JSON.parse(JSON.stringify(intitalProfileState))
  ); // deep clone
  const [modalViewType, setModalViewType] = useState({
    type: "",
    urls: [],
  }); // url, press, social, moods, facebook, instagram,  artwork, additional,
  const [modalContentView, setModalContentView] = useState({
    show: false,
    component: null,
  });
  const [viewDetailsModal, setViewDetailsModal] = useState(null);
  const [detailsData, setDetailsData] = useState();
  const [count, setCount] = useState(0);
  const [filters, setFilters] = useState({
    limit: 20,
    offset: 0,
    page: 1,
  });
  const [lyricalData, setLyricalData] = useState({});

  useEffect(() => {
    setInitialData();
  }, [pathname]);

  useEffect(() => {
    onGetSongsByRelease();
  }, [selectedRelease]);

  let guidelinesToolsArray = "";
  if (toolType === "playlist") {
    guidelinesToolsArray = guidelinesTools;
  } else guidelinesToolsArray = guidelinesToolsLyrics;

  const setInitialData = async () => {
    try {
      let toolTypePath = "profile";
      if (pathname === "/marketing/playlist-pitchment") {
        toolTypePath = "playlist";
        setData(JSON.parse(JSON.stringify(intitalPlaylistState)));
      } else if (pathname === "/tools/distribute-lyrics") {
        toolTypePath = "lyrics";
      } else {
        toolTypePath = "profile";
        setData(JSON.parse(JSON.stringify(intitalProfileState)));
      }
      setToolType(toolTypePath);
      if (toolTypePath !== toolType) {
        setDataHistory(null);
      }
      getInitialData(toolTypePath, filters);
      setSelectedRelease(null);
      setselectedSong(null);
    } catch (ex) {
      setLoader(false);
    }
  };

  const getInitialData = async (toolType, filters = {}) => {
    try {
      let releaseActions = Promise.resolve({});
      let historyAction = Promise.resolve({});
      if (toolType === "profile") {
        releaseActions = actions.getReleaseTitles;
        historyAction = actions.getProfileLinkingHistory;
      } else if (toolType === "lyrics") {
        releaseActions = actions.getReleaseTitles;
        historyAction = actions.getLyricsHistory;
      } else {
        releaseActions = actions.getReleaseTitlesPlaylist;
        historyAction = actions.getPlaylistPitchHistory;
      }
      setLoader(true);
      const [{ body: releases = [] }, { body: dataHistory = [], total = 0 }] =
        await Promise.all([releaseActions(), historyAction(filters)]);
      setReleases(
        releases.map((item) => ({
          ...item,
          label: item.release_title,
          value: item.release_id,
        }))
      );
      setCount(total);
      setDataHistory(dataHistory);
      setLoader(false);
    } catch (ex) {
      setLoader(false);
    }
  };

  const onGetSongsByRelease = async () => {
    try {
      if (!selectedRelease.release_id) return;
      setSongs([]);
      setselectedSong(null);
      setLoader(true);
      const { body: songs = [] } =
        (await actions.getAudioTitlesByReleaseId(selectedRelease.release_id)) ||
        {};
      setSongs(
        songs.map((item) => ({
          ...item,
          label: item.title,
          value: item.audio_id,
        }))
      );
      setLoader(false);
    } catch (ex) {
      setLoader(false);
    }
  };

  const onPageChange = (event, page) => {
    const offset = (page - 1) * filters.limit;
    const newFilters = { ...filters, page, offset };
    setFilters(newFilters);
    getInitialData(toolType, newFilters);
  };

  const onHandleChange = (e = {}) => {
    const { name = "", value = "" } = e.target || {};
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const onHandleModalView = (type, urls = []) => {
    setModalViewType({
      type,
      urls: !urls.length && type !== "moods" ? [""] : urls,
    });
  };

  const onChangeMoods = (action, value) => {
    let updatedMoods = [...data.moods];
    if (action === "update") {
      if (value === "None of these") {
        updatedMoods = [value];
      } else {
        updatedMoods.push(value);
      }
    } else {
      updatedMoods = updatedMoods.filter((item) => item !== value);
    }
    setData((prev) => ({ ...prev, moods: updatedMoods }));
  };

  const onChangeUrls = (action, type, value, index) => {
    const updatedData = { ...data };
    if (type === "moods") {
      if (action === "update") {
        const prevdata = { ...modalViewType };
        prevdata.urls.push(value);
        setModalViewType(prevdata);
      } else {
        const updatedMoods = modalViewType.urls.filter(
          (item) => item !== value
        );
        setModalViewType((prev) => ({ ...prev, urls: updatedMoods }));
      }
    } else {
      if (action === "add") {
        setModalViewType((prev) => ({ ...prev, urls: [...prev.urls, ""] }));
        updatedData[type].push("");
      } else if (action === "delete") {
        const prevdata = { ...modalViewType };
        prevdata.urls.splice(index, 1);
        setModalViewType(prevdata);
      } else if (action === "update") {
        const prevdata = { ...modalViewType };
        prevdata.urls[index] = value;
        setModalViewType(prevdata);
      }
    }
  };

  const onAddUrls = () => {
    const { type, urls = [] } = modalViewType;
    if (type !== "moods") {
      if (!urls.length) return;
      for (let i = 0; i < urls.length; i++) {
        const isValid = isValidUrl(urls[i]);
        if (!isValid) {
          toastError(`Invalid URL at position ${i + 1}`);
          return;
        }
      }
    }
    const updatedData = { ...data };
    updatedData[type] = urls;
    setData(updatedData);
    setModalViewType({
      type: "",
      urls: [],
    });
  };

  const onSubmitForm = async () => {
    if (!selectedRelease || !selectedRelease?.label || !selectedSong?.label) {
      toastError(`Please fill all mandatory fields`);
      return;
    }

    try {
      let request = {};
      let sendObj = {
        release_id: selectedRelease.value,
        release_title: selectedRelease.label,
        audio_title: selectedSong.label,
      };

      if (toolType === "profile") {
        if (!data.artist || !data.facebook_link || !data.instagram_link) {
          toastError(`Please fill all mandatory fields`);
          return;
        }
        if (!!data.facebook_link) {
          if (!isValidUrl(data.facebook_link)) {
            return toastError(`Invalid Facebook Link`);
          }
        }
        if (!!data.instagram_link) {
          if (!isValidUrl(data.instagram_link)) {
            return toastError(`Invalid Instagram Link`);
          }
        }
        sendObj = {
          ...sendObj,
          artist: data.artist,
          facebook_link: data.facebook_link,
          instagram_link: data.instagram_link,
        };
        request = actions.submitProfileLinking;
      } else if (toolType === "lyrics") {
        if (
          !lyricalData.lyrics_language ||
          !lyricalData.p_rights ||
          !lyricalData.lyrics
        ) {
          toastError(`Please fill all mandatory fields`);
          return;
        }
        sendObj = {
          ...sendObj,
          ...lyricalData,
        };
        request = actions.submitDistributeLyrics;
      } else {
        if (
          data.social_media.length === 0 ||
          !data.why_pitch ||
          !data.quick_pitch ||
          data.moods.length === 0
        ) {
          toastError(`Please fill all mandatory fields`);
          return;
        }
        if (!!data.additional_assets) {
          if (!isValidUrl(data.additional_assets)) {
            return toastError(`Invalid Additional Assets`);
          }
        }
        sendObj = {
          ...sendObj,
          press_release: data.press_release,
          social_media: data.social_media,
          artwork_asset: data.artwork_asset,
          additional_assets: data.additional_assets,
          moods: data.moods,
          why_pitch: data.why_pitch,
          quick_pitch: data.quick_pitch,
          additional_info: data.additional_info,
        };
        request = actions.submitPitchPlaylist;
      }

      setLoader(true);
      await request(sendObj);
      setLyricalData({});
      setSelectedFileName("");
      await setInitialData();
      toastSuccess("Submission successful.");
    } catch (ex) {
      setLoader(false);
      toastError(ex.message);
    }
  };

  const handleViewDetails = (data) => {
    setDetailsData(data);
    setViewDetailsModal(true);
  };

  const renderModalViewContent = (renderType, content) => {
    let component = null;
    switch (renderType) {
      case "urls": {
        component = (
          <Box>
            {Array.isArray(content) && content.length
              ? content.map((item) => {
                  return (
                    <Box textAlign="center" mb={1}>
                      <a href={item} target="_blank">
                        {item}
                      </a>
                    </Box>
                  );
                })
              : null}
          </Box>
        );
        break;
      }
      case "": {
        // other cases
        component = <></>;
      }
      default:
        component = null;
    }
    setModalContentView({ show: true, component });
  };

  const selectedPolicy = useMemo(
    () => policyOptions.find((item) => item.value === data.policy),
    [data]
  );
  const selectedPlatform = useMemo(
    () => platformOptions.find((item) => item.value === data.platform),
    [data]
  );

  const heading = useMemo(() => {
    let heading = "Profile Linking";
    if (toolType === "playlist") {
      heading = "Playlist Pitchment";
    } else if (toolType === "lyrics") {
      heading = "Distribute Lyrics";
    }
    return heading;
  }, [toolType]);

  let totalPages = Math.ceil(Number(count) / filters.limit);

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  const fileInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState("");

  const handleFileInputChange = (event) => {
    setLoader(true);
    const file = event.target.files[0];
    setSelectedFileName(file.name);

    const data1 = new FormData();
    data1.append("file", file);
    axios
      .post(`${API_URL}/api/videoUpload`, data1, {
        headers: {
          ...getHeaders(),
        },
      })
      .then((res) => {
        setLoader(false);
        toastSuccess(res.data.message);
        setLyricalData({
          ...lyricalData,
          lrc_link: `${API_URL}/${res.data.body.filename}`,
        });
      })
      .catch((err) => {
        setLoader(false);
        toastError(err.message);
      });
  };

  const handleButtonClick = () => {
    // Trigger the file input dialog when the button is clicked
    fileInputRef.current.click();
  };

  const getDescription = () => {
    if (toolType === "playlist") {
      return "Pitch your releases to editorial playlists and increase your music's visibility.";
    } else if (toolType === "lyrics") {
      return "Distribute and sync lyrics for your tracks across all major music platforms.";
    }
    return "Link and manage your artist profiles across different music streaming platforms.";
  };

  return (
    <>
    <SEO
      title={heading}
      description={getDescription()}
    />
    <PageContainer>
      <Fade in timeout={800}>
        <Box>
          <PageHeader>
            <Typography variant="h1">{heading}</Typography>
          </PageHeader>

          {toolType === "playlist" && (
            <>
              <WarningCard>
                <WarningAmberIcon className="warning-icon" />
                <div className="warning-content">
                  <p>
                    You can only pitch your new upcoming releases with this tool. For more info please email us at support@fronicmedia.com
                  </p>
                </div>
              </WarningCard>
              <WarningCard sx={{ background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)', borderColor: '#e53935' }}>
                <WarningAmberIcon className="warning-icon" sx={{ color: '#c62828' }} />
                <div className="warning-content">
                  <p>
                    <strong>NOTE:</strong> We can't guarantee a place on an editorial playlist when we pitch music. It's at the discretion of the Editorial team when they select tracks.
                  </p>
                </div>
              </WarningCard>
            </>
          )}

          {(toolType === "playlist" || toolType === "lyrics") && (
            <Box display="flex" justifyContent="flex-end" mb={2}>
              <Typography
                onClick={() => setGuidelinesOpen(true)}
                sx={{
                  color: '#1a73e8',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: "'DM Sans', sans-serif",
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                VIEW GUIDELINES
              </Typography>
            </Box>
          )}

          <Grid container justifyContent="center">
            <Grid item xs={12} lg={10} xl={8}>
              <FormCard>
                <Grid container spacing={3}>
          <>
            <Grid item xs={12} sm={6}>
              <StyledInputLabel>
                <MusicNoteIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />
                Select Release<span className="required-span">*</span>
              </StyledInputLabel>
              <SelectCmp
                styles={selectStyles}
                options={releases}
                value={selectedRelease}
                placeholder="Select Release"
                onChange={setSelectedRelease}
                menuPortalTarget={document.body}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <StyledInputLabel>
                <MusicNoteIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />
                Select Audio<span className="required-span">*</span>
              </StyledInputLabel>
              <SelectCmp
                styles={selectStyles}
                options={songs}
                value={selectedSong}
                placeholder="Select Audio"
                onChange={setselectedSong}
                menuPortalTarget={document.body}
              />
            </Grid>
          </>

          {toolType === "profile" && (
            <>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  <PersonIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />
                  Artist<span className="required-span">*</span>
                </StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="artist"
                  fullWidth
                  placeholder="Make sure to enter the exact name of artist"
                  size="small"
                  value={data.artist || ""}
                  onChange={(e) => onHandleChange(e)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  <Facebook sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />
                  Facebook Link<span className="required-span">*</span>
                </StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="facebook_link"
                  fullWidth
                  placeholder="Enter the URL of the artist's Facebook page/account"
                  size="small"
                  value={data.facebook_link || ""}
                  onChange={(e) => onHandleChange(e)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  <Instagram sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />
                  Instagram Link<span className="required-span">*</span>
                </StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="instagram_link"
                  fullWidth
                  placeholder="Enter the URL of the artist's Instagram account"
                  size="small"
                  value={data.instagram_link || ""}
                  onChange={(e) => onHandleChange(e)}
                />
              </Grid>
            </>
          )}
          {toolType === "playlist" && (
            <>
              <Grid item xs={12}>
                <StyledInputLabel>
                  Why are you pitching this song?
                  <span className="required-span">*</span>
                </StyledInputLabel>
                  <CssTextField
                    variant="outlined"
                    name="why_pitch"
                    fullWidth
                    placeholder="Describe the artist, the release, and any marketing or promotion efforts in detail. Only include a brief summary of important information in your copy. Always keep the most important details or sentences at the top!"
                    size="small"
                    value={data.why_pitch || ""}
                    onChange={(e) => onHandleChange(e)}
                    multiline
                    rows="4"
                    inputProps={{
                      maxlength: 500,
                    }}
                    helperText={`${data.why_pitch.length}/${500}`}
                  />
              </Grid>

              <Grid item xs={12}>
                <StyledInputLabel>
                  Quick Pitch<span className="required-span">*</span>
                </StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="quick_pitch"
                  fullWidth
                  placeholder="One-sentence description of the release. Be unique!"
                  size="small"
                  value={data.quick_pitch || ""}
                  onChange={(e) => onHandleChange(e)}
                  multiline
                  rows="2"
                  inputProps={{
                    maxlength: 100,
                  }}
                  helperText={`${data.quick_pitch.length}/${100}`}
                />
              </Grid>

              <Grid item xs={12}>
                <StyledInputLabel>Artwork Asset (PSD File of artwork)</StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="artwork_asset"
                  fullWidth
                  placeholder="Make sure the file/transfer is unlocked"
                  size="small"
                  value={data.artwork_asset || ""}
                  onChange={(e) => onHandleChange(e)}
                />
              </Grid>
              <Grid item xs={12}>
                <StyledInputLabel>
                  Additional Assets (Artist Bytes, Promotional Clips etc)
                </StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="additional_assets"
                  fullWidth
                  placeholder="Additional Assets"
                  size="small"
                  value={data.additional_assets || ""}
                  onChange={(e) => onHandleChange(e)}
                />
              </Grid>

              <Grid item xs={12}>
                <StyledInputLabel>Additional Information</StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="additional_info"
                  fullWidth
                  placeholder="Write down some additional information"
                  size="small"
                  value={data.additional_info || ""}
                  onChange={(e) => onHandleChange(e)}
                  multiline
                  rows="3"
                  inputProps={{
                    maxlength: 250,
                  }}
                  helperText={`${data.additional_info.length}/${250}`}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <StyledInputLabel>Link to Press Release</StyledInputLabel>
                <span
                  style={{
                    color: "#1a73e8",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                  onClick={() =>
                    onHandleModalView(
                      "press_release",
                      data.press_release || []
                    )
                  }
                >
                  {(data.press_release && data.press_release.length) || 0}{" "}
                  Link added (Click to add)
                </span>
              </Grid>

              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Artist's social links (Instagram, Facebook, Twitter etc)
                  <span className="required-span">*</span>
                </StyledInputLabel>
                <span
                  style={{
                    color: "#1a73e8",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                  onClick={() =>
                    onHandleModalView("social_media", data.social_media || [])
                  }
                >
                  {(data.social_media && data.social_media.length) || 0} Links
                  added (Click to add)
                </span>
              </Grid>

              <Grid item xs={12}>
                <StyledInputLabel>
                  Moods<span className="required-span">*</span>
                </StyledInputLabel>
                <Box style={{ gap: "10px" }} display="flex" flexWrap="wrap" mt={1}>
                  {moodsOptions.map((item) => {
                    const isSelected = data.moods.includes(item);

                    let isDisabled =
                      (data.moods.includes("None of these") &&
                        item !== "None of these") ||
                      (data.moods.length === 2 &&
                        item !== data.moods[0] &&
                        item !== "None of these");
                    if (isSelected) {
                      return (
                        <Chip
                          key={item}
                          disabled={isDisabled}
                          label={item}
                          onDelete={() => onChangeMoods("delete", item)}
                          color="primary"
                          sx={{
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: 600,
                          }}
                        />
                      );
                    }
                    return (
                      <Chip
                        key={item}
                        disabled={isDisabled}
                        label={item}
                        onClick={() => onChangeMoods("update", item)}
                        variant="outlined"
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderColor: '#e0e0e0',
                          color: '#202124',
                          fontFamily: "'DM Sans', sans-serif",
                          fontWeight: 500,
                          '&:hover': {
                            backgroundColor: '#e3f2fd',
                            borderColor: '#1a73e8',
                          },
                        }}
                      />
                    );
                  })}
                </Box>
              </Grid>
            </>
          )}
          {toolType === "lyrics" && (
            <>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  <MusicNoteIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'text-bottom' }} />
                  Lyrics Language<span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  options={trackTitleLanguage}
                  value={{
                    label: lyricalData.lyrics_language,
                    value: lyricalData.lyrics_language,
                  }}
                  placeholder="Select Lyrics Language"
                  onChange={(e) => {
                    setLyricalData({
                      ...lyricalData,
                      lyrics_language: e.value,
                    });
                  }}
                  menuPortalTarget={document.body}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>
                  Do you own the publishing rights of the lyrics?
                  <span className="required-span">*</span>
                </StyledInputLabel>
                <SelectCmp
                  styles={selectStyles}
                  options={[
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                    { label: "Not Sure", value: "Not Sure" },
                    {
                      label: "Public Domain Content",
                      value: "Public Domain Content",
                    },
                  ]}
                  value={{
                    label: lyricalData.p_rights,
                    value: lyricalData.p_rights,
                  }}
                  placeholder="Select Your Response"
                  onChange={(e) =>
                    setLyricalData({
                      ...lyricalData,
                      p_rights: e.value,
                    })
                  }
                  menuPortalTarget={document.body}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>ISWC</StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="iswc"
                  fullWidth
                  placeholder="Enter ISWC code"
                  size="small"
                  value={lyricalData.iswc || ""}
                  onChange={(e) =>
                    setLyricalData({
                      ...lyricalData,
                      iswc: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledInputLabel>Upload LRC</StyledInputLabel>
                <div className="custom-file-input-container">
                  <button
                    onClick={handleButtonClick}
                    className="custom-file-input-button"
                  >
                    Choose File
                  </button>
                  <div className="custom-file-input-selected">
                    <span>{selectedFileName}</span>
                    {selectedFileName && (
                      <CheckCircleIcon className="checkmark-icon" />
                    )}
                  </div>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileInputChange}
                    accept=".lrc"
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <StyledInputLabel>
                  Lyrics
                  <span className="required-span">*</span>
                </StyledInputLabel>
                <CssTextField
                  variant="outlined"
                  name="lyrics"
                  fullWidth
                  placeholder="You can paste the lyrics here. Make sure to follow the spacing and formatting"
                  size="small"
                  value={lyricalData.lyrics || ""}
                  onChange={(e) =>
                    setLyricalData({
                      ...lyricalData,
                      lyrics: e.target.value,
                    })
                  }
                  multiline
                  rows="6"
                />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <StyledButton onClick={onSubmitForm}>
                <SaveIcon style={{ marginRight: "8px", fontSize: 17 }} /> Submit
              </StyledButton>
            </Box>
          </Grid>
        </Grid>
              </FormCard>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12}>
              <SectionTitle>
                <HistoryIcon sx={{ color: '#1a73e8', fontSize: 28, mr: 1, verticalAlign: 'text-bottom' }} />
                Your {heading} History
              </SectionTitle>
        <Box mt={4}>
          <StyledTableContainer component={Paper}>
            <Table>
              <StyledTableHead>
                <TableRow>
                  <>
                    <TableCell>Release Title</TableCell>
                    <TableCell>Audio Title</TableCell>
                  </>

                  {toolType === "lyrics" && <TableCell>Language</TableCell>}
                  {toolType === "profile" && <TableCell>Artist</TableCell>}
                  {toolType === "profile" && <TableCell align="left">FB</TableCell>}
                  {toolType === "profile" && <TableCell align="left">IG</TableCell>}
                  <TableCell>Status</TableCell>
                  {toolType === "playlist" && (
                    <TableCell>Press Release</TableCell>
                  )}
                  {toolType === "playlist" && (
                    <TableCell>Social Links</TableCell>
                  )}
                  {toolType === "playlist" && <TableCell>Details</TableCell>}
                  <TableCell>Date</TableCell>
                  {toolType === "lyrics" && <TableCell>Details</TableCell>}
                </TableRow>
              </StyledTableHead>

              <TableBody>
                {Array.isArray(dataHistory) && dataHistory.length
                  ? dataHistory.map((item, index) => {
                      return (
                        <StyledTableRow key={index}>
                          <TableCell>{item.release_title || ""}</TableCell>
                          <TableCell>{item.audio_title || ""}</TableCell>

                          {toolType === "lyrics" && (
                            <TableCell>{item.lyrics_language}</TableCell>
                          )}

                          {toolType === "profile" && (
                            <TableCell>{item.artist}</TableCell>
                          )}
                          {toolType === "profile" && (
                            <TableCell
                              align="left"
                              style={{ cursor: "pointer" }}
                              onClick={() => openInNewTab(item.facebook_link)}
                            >
                              <Facebook sx={{ color: '#1877F2', fontSize: 28 }} />
                            </TableCell>
                          )}
                          {toolType === "profile" && (
                            <TableCell
                              align="left"
                              style={{ cursor: "pointer" }}
                              onClick={() => openInNewTab(item.instagram_link)}
                            >
                              <Instagram sx={{ color: '#E4405F', fontSize: 28 }} />
                            </TableCell>
                          )}
                          <TableCell align="left">
                            <p>
                              {item.status === "in_review" ? (
                                <LightTooltip title="In Review">
                                  <AccessTimeIcon />
                                </LightTooltip>
                              ) : item.status === "rejected" ? (
                                <LightTooltip title="Rejected">
                                  <CancelIcon style={{ color: "red" }} />
                                </LightTooltip>
                              ) : (
                                <LightTooltip title="Approved">
                                  <CheckCircleIcon style={{ color: "green" }} />
                                </LightTooltip>
                              )}
                            </p>
                          </TableCell>
                          {toolType === "playlist" && (
                            <TableCell>
                              {item.press_release &&
                              !!item.press_release.length ? (
                                <span
                                  style={{
                                    color: "#1a73e8",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontFamily: "'DM Sans', sans-serif",
                                  }}
                                  onClick={() =>
                                    renderModalViewContent(
                                      "urls",
                                      item.press_release
                                    )
                                  }
                                >
                                  {item.press_release.length} Link(s)
                                </span>
                              ) : (
                                <span>No Links</span>
                              )}
                            </TableCell>
                          )}
                          {toolType === "playlist" && (
                            <TableCell>
                              {item.social_media &&
                              !!item.social_media.length ? (
                                <span
                                  style={{
                                    color: "#1a73e8",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontFamily: "'DM Sans', sans-serif",
                                  }}
                                  onClick={() =>
                                    renderModalViewContent(
                                      "urls",
                                      item.social_media
                                    )
                                  }
                                >
                                  {item.social_media.length} Link(s)
                                </span>
                              ) : (
                                <span>No Links</span>
                              )}
                            </TableCell>
                          )}
                          {toolType === "playlist" && (
                            <TableCell>
                              <span
                                style={{
                                  color: "#1a73e8",
                                  cursor: "pointer",
                                  fontWeight: 600,
                                  fontFamily: "'DM Sans', sans-serif",
                                }}
                                onClick={() => handleViewDetails(item)}
                                onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                                onMouseOut={(e) => e.target.style.textDecoration = "none"}
                              >
                                View Pitch
                              </span>
                            </TableCell>
                          )}
                          <TableCell>{item.date || ""}</TableCell>
                          {toolType === "lyrics" && (
                            <TableCell>
                              <span
                                style={{
                                  color: "#1a73e8",
                                  cursor: "pointer",
                                  fontWeight: 600,
                                  fontFamily: "'DM Sans', sans-serif",
                                }}
                                onClick={() => handleViewDetails(item)}
                                onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                                onMouseOut={(e) => e.target.style.textDecoration = "none"}
                              >
                                View Details
                              </span>
                            </TableCell>
                          )}
                        </StyledTableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
              <Pagination
                count={totalPages}
                showFirstButton
                showLastButton
                onChange={onPageChange}
                page={filters.page || 0}
                sx={{
                  '& .MuiPaginationItem-root': {
                    fontFamily: "'DM Sans', sans-serif",
                    fontWeight: 600,
                    color: '#1a73e8',
                  },
                  '& .Mui-selected': {
                    background: 'linear-gradient(135deg, #1a73e8 0%, #00bfa5 100%)',
                    color: 'white',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #1557b0 0%, #009688 100%)',
                    },
                  },
                }}
              />
            </Box>
          </StyledTableContainer>
        </Box>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </PageContainer>
      <CustomShowModal
        open={guidelinesOpen}
        handleClose={() => setGuidelinesOpen(false)}
        maxWidth="md"
        title="GUIDELINES"
      >
        {guidelinesToolsArray.map((item, key) => {
          return (
            <div style={{ display: "flex", padding: 5 }} key={key}>
              {key !== 0 ? (
                <span style={{ fontWeight: 600, marginRight: 5 }}>{key}.</span>
              ) : null}
              <p> {item}</p>
            </div>
          );
        })}
      </CustomShowModal>

      <CustomShowModal
        open={!!modalViewType.type}
        handleClose={() => setModalViewType({ type: "", urls: [] })}
        maxWidth="sm"
        title={modalViewType.type === "moods" ? "Select Moods" : "Add Url(s)"}
      >
        {generateModalContent(modalViewType, onChangeUrls, onAddUrls)}
      </CustomShowModal>

      <CustomShowModal
        open={modalContentView.show}
        handleClose={() =>
          setModalContentView({ show: false, component: null })
        }
        maxWidth="sm"
        title="View"
      >
        {modalContentView.component}
      </CustomShowModal>
      <CustomShowModal
        open={viewDetailsModal}
        handleClose={() => setViewDetailsModal(false)}
        maxWidth="sm"
        title={detailsData?.release_title || "Details"}
      >
        {toolType === "playlist" && (
          <div>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Artwork Assets:</strong>
              <br />
              <a href={detailsData?.artwork_asset}>
                {detailsData?.artwork_asset}
              </a>
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Additional Assets:</strong>
              <br />
              <a href={detailsData?.additional_assets}>
                {detailsData?.additional_assets}
              </a>
            </p>
            <strong>Moods:</strong>
            <ul>
              {detailsData?.moods.map((item) => {
                return <li>{item}</li>;
              })}
            </ul>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Your Pitch:</strong>
              <br />
              {detailsData?.why_pitch}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Quick Pitch:</strong>
              <br />
              {detailsData?.quick_pitch}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Additional Information:</strong>
              <br />
              {detailsData?.additional_info}
            </p>
          </div>
        )}

        {toolType === "lyrics" && (
          <div>
            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>Publishing rights:</strong>
              <br />
              {detailsData?.p_rights}
            </p>

            <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <strong>ISWC:</strong>
              <br />
              {detailsData?.iswc}
            </p>
            {/* <p style={{ wordBreak: "break-all", paddingBottom: "5px" }}>
              <a
                href={detailsData?.lrc_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>Download LRC</strong>
              </a>
            </p> */}

            <p style={{ whiteSpace: "break-spaces", paddingBottom: "5px" }}>
              <strong>Lyrics:</strong>
              <br />
              {detailsData?.lyrics}
            </p>
          </div>
        )}
      </CustomShowModal>
    </>
  );
}

const generateModalContent = (viewType, onChangeUrls, onAddUrls) => {
  const { type = "", urls = [] } = viewType;
  return (
    <Box>
      {type === "moods" ? (
        <>
          <Box style={{ gap: "10px" }} display="flex" flexWrap="wrap">
            {moodsOptions.map((item) => {
              const isSelected = urls.includes(item);
              if (isSelected) {
                return (
                  <Chip
                    label={item}
                    onDelete={() => onChangeUrls("delete", type, item, null)}
                    color="primary"
                  />
                );
              }
              return (
                <Chip
                  label={item}
                  onClick={() => onChangeUrls("update", type, item, null)}
                />
              );
            })}
          </Box>
          <Box mt={3} textAlign="center">
            {urls.length ? <span>{urls.length} Moods selected</span> : null}
          </Box>
        </>
      ) : (
        urls.map((item, index) => {
          const isValid = isValidUrl(item);
          return (
            <Box
              key={index}
              mb={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <CssTextField
                variant="outlined"
                fullWidth
                placeholder={`Enter url ${index + 1}`}
                size="small"
                value={item}
                error={!isValid}
                onChange={(e) =>
                  onChangeUrls("update", type, e.target.value, index)
                }
              />
              {urls.length - 1 !== index || index > 8 || !isValid ? (
                <RemoveIcon
                  className="add-icon-button delete"
                  onClick={() => onChangeUrls("delete", type, null, index)}
                />
              ) : (
                <AddIcon
                  className="add-icon-button"
                  onClick={() => onChangeUrls("add", type, null, null)}
                />
              )}
            </Box>
          );
        })
      )}
      <Box mt={3} display="flex" justifyContent="center">
        <StyledButton onClick={onAddUrls}>Save</StyledButton>
      </Box>
    </Box>
  );
};
